// LICENSE_CODE MIT
/* eslint-disable */
export default {
  "sentry": {
    "front": {
      "dsn": "xxx"
    },
    "back": {
      "dsn": "yyy"
    }
  },
  "auth0": {},
  "sbase": {},
  "google": {
    "dv360_client_id": "395108856895-f2vt6ocb3f163eg67m4gh3246hhj8ml6.apps.googleusercontent.com"
  },
  "cognito": {
    "pool_id": "il-central-1_t0NzUbXbA",
    "client_id": "7j2ulcbmgi56jd62jeragslhjo"
  },
  "front": {
    "company_lbl": "BackStage Technologies Ltd",
    "email": "support@bstage.io",
    "email_legal": "legal@bstage.io",
    "email_noreply": "noreply@bstage.io",
    "phone": "+972543088148",
    "phone_lbl": "+972-54-308-8148",
    "addr_lbl": "12 Abba Hillel St., Ramat Gan, Israel",
    "addr_lbl_he": "אבא הלל 12, רמת גן",
    "url": "https://bstage.io",
    "app": {
      "url": "https://www.bstage.io",
      "url_www": "https://www.bstage.io"
    }
  },
  "back": {
    "app": {
      "url": "https://api.bstage.io"
    },
    "api": {
      "url": "https://api2.bstage.io"
    },
    "ws": {
      "url": "http://backstage_ws.bstage.io"
    },
    "media": {
      "url": "https://backstage.erate.co.il"
    },
    "preview": {
      "url": "https://media2.bstage.io"
    }
  },
  "domain": "bstage.io",
  "is_prod": true,
  "ver": "1.0.24",
  "is_local": false,
  "stage": "prod",
  "bucket_ext": "bs-front-share-prod"
}